import { usePathname } from 'expo-router'

type PhoneScreen = 'product-catalog' | 'order-finalization'

export const usePhoneActiveScreen = (): PhoneScreen | undefined => {
    const pathname = usePathname()

    switch (pathname) {
        case '/phone/1-product-catalog':
            return 'product-catalog'
        case '/phone/2-order-finalization':
            return 'order-finalization'
        default:
            return undefined
    }
}
